module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/2@2x_3cb70db2592712ec6bfb0e8e1368e13a.png";